export const ActionTypes = {
  ADD_EMPLOYESS: "ADD_EMPLOYESS",
  LIST_EMPLOYEES: "LIST_EMPLOYEES",
  EDIT_EMPLOYEES: "EDIT_EMPLOYEES",
  DELETE_EMPLOYEES: "DELETE_EMPLOYEES",
};
